import React from "react";
import ProjectUploadForm from "../molecules/ProjectUploadForm";
import TransitionWrapper from "../atoms/TransitionWrapper";

const ProjectUpload = () => {
    return (
        <TransitionWrapper>
            {/* <div className="bg-gray-100 w-full h-full p-6">
                <div className="text-2xl font-bold mb-4">
                    Upload New Projects
                </div> */}
                <ProjectUploadForm />
            {/* </div> */}
        </TransitionWrapper>
    );
};
export default ProjectUpload;
